import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { grey } = colors

const Eye = (props: Icon) => {
    const { color = grey, size = 24, className = 'eye' } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24">
            <g fill={color} fillRule="evenodd">
                <path d="M14.759 9.411c.001.026.004.052.004.078a1.593 1.593 0 11-2.419-1.36 3.592 3.592 0 102.415 1.282" />
                <path d="M12.092 3a8.68 8.68 0 00-6.345 2.746C4.285 7.303 2 10.795 2 11.704c0 .835 2.264 4.352 3.698 5.904a8.68 8.68 0 006.394 2.8 8.682 8.682 0 006.425-2.832c1.416-1.548 3.39-4.998 3.39-5.872 0-.987-1.976-4.329-3.395-5.877A8.681 8.681 0 0012.092 3m0 2.778c1.683 0 3.235.683 4.372 1.925.938 1.024 2.14 3.008 2.563 3.974-.43.962-1.618 2.994-2.56 4.024a5.941 5.941 0 01-4.374 1.928 5.866 5.866 0 01-4.355-1.906c-.952-1.03-2.249-3-2.796-4.037.537-1.027 1.832-2.976 2.83-4.038a5.87 5.87 0 014.32-1.87" />
            </g>
        </svg>
    )
}

export { Eye }
